import React, { useRef, useEffect, useState,useCallback } from 'react';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CssBaseline from '@mui/material/CssBaseline';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { alpha } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import axios from 'axios'
import { format,parseISO } from 'date-fns'
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import LinearProgress from '@mui/material/LinearProgress';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardTimePicker,
} from '@material-ui/pickers';

import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import InputAdornment from '@mui/material/InputAdornment';
import EventIcon from '@mui/icons-material/Event';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import SyncIcon from '@mui/icons-material/Sync';
import TimerSharpIcon from '@mui/icons-material/TimerSharp';

import ViewSynclogsFunctions from "./ViewSyncLogsFunctions";
import ViewUserSyncLogsFunctions from "./ViewUserSyncLogsFunctions";
import ViewUserDaysWithSyncLogsFunctions from "./ViewUserDaysWithSyncLogsFunctions";

const useStyles = makeStyles((theme) => ({
    appBar: {
        [theme.breakpoints.up('sm')]: {
          width: `calc(100% - ${drawerWidth}px)`,
          marginLeft: drawerWidth,
        },
      },
      menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
          display: 'none',
        },
      },
    search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: alpha(theme.palette.common.white, 0.15),
      '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
      },
      marginRight: theme.spacing(2),
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(3),
        width: 'auto',
      }
     
    },
    appBarBottom: {
      top: 'auto',
      bottom: 0,
      backgroundColor:"#ffffff",
      [theme.breakpoints.up('sm')]: {
          width: `calc(100% - ${drawerWidth}px)`,
          marginLeft: drawerWidth,
        },
    },
    grow: {
      flexGrow: 1,
    },
    deleteIcon: {
      margin : "0 0 0 10px"
    }
  
}));

const materialTheme = createTheme(({
    // set default for now
   
  }));

const drawerWidth = 300;

export default function SellerSyncLogs(props) {
    
    const defaultStartingDate = new Date();
    // defaultStartingDate.setMonth(defaultStartingDate.getMonth() -1);

    const classes = useStyles();
    const [,setAnchorEl] = useState(null);
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const openMenu = Boolean(menuAnchorEl);
    const [, setAppBarWidth] = useState(0);
    const lastSyncLogsElementObserver = useRef()

    const [startingDate, setStartingDate] = React.useState(defaultStartingDate);
    const [endingDate, setEndingDate] = React.useState(new Date());
    const [openDateFilterDialog,setOpenDateFilterDialog] = useState(false)
    const [openStartingDateCalendar, setOpenStartingDateCalendar] = useState(false)
    const [openEndingDateCalendar, setOpenEndingDateCalendar] = useState(false)
    const [startingFilterDate,setStartingFilterDate] = useState(defaultStartingDate)
    const [hasErrorFetchingUsername,setHasErrorFetchingUsername] = useState(false)
    const [endingFilterDate,setEndingFilterDate] = useState(new Date())
    const [loadData,setLoadData] = useState(true)
    const [loadUsernames,setLoadUsernames] = useState(true)
    const [searchUsername, setSearchUsername] = useState({name:""});
    const [autoCompleteSearchOptionMessage,setAutoCompleteSearchOptionMessage] = useState("Searching...")
    const [pageNumber,setPageNumber] = useState(1)
    const [isLoading,setIsLoading] = useState(true)
    const [hasLoadingMore, setHasLoadingMore] = useState(false)
    const [syncLogsData,setSyncLogsData] = useState([])
    const [autoSuggestUsernames, setAutoSuggestUsernames] = useState([])
    const [hasMoreSyncLogsToLoad, setHasMoreSyncLogsToLoad] = useState(true)
    const [selectedUser, setSelectedUser] = useState();
    const [selectedUserAnchorElement,setSelectedUserAnchorElement] = useState(null)
    const [syncLogsActions, setSyncLogsActions] = useState("");
    const [openSyncLogsFunctionDialog, setOpenSyncLogsFunctionDialog] = useState(false)
    const [dateError, setDateError] = useState(false);
    
    const menuHandleClick = (event) => {
        setMenuAnchorEl(event.currentTarget);
    };

    const menuHandleClose = () => {
        setMenuAnchorEl(null)
    };

    const lastSyncLogsElement = useCallback(node=>{
      if(isLoading){
          return
      }
      if(lastSyncLogsElementObserver.current){
        lastSyncLogsElementObserver.current.disconnect()
      }
      lastSyncLogsElementObserver.current = new IntersectionObserver(entries=>{
        if(entries[0].isIntersecting && hasMoreSyncLogsToLoad){
          
          lastSyncLogsElementObserver.current.disconnect()
          setPageNumber(prevPageNumber => prevPageNumber + 1)
          setHasLoadingMore(true)
          setIsLoading(true)
        }
  
      })
      
      if(node){
        lastSyncLogsElementObserver.current.observe(node)
      }
    },[isLoading, hasMoreSyncLogsToLoad])

    useEffect(() => {

      function fetchAutoSuggestSellerUsername(searchString) {

          const loadUsernames = async () => {

              setAutoCompleteSearchOptionMessage("Searching.")

              const options = {
                  method: 'POST',
                  url: '/TransactiSellerSyncLogs/getUsernameForAutoSuggests.json',
                  data: objectToFormData({search_term:searchString})
              }

              await axios(options)
              .then((res) => {

                const usernames = res.data.response.SyncLogs

                if (usernames.length <= 0) {
                  setAutoCompleteSearchOptionMessage("No record found.")
                  setAutoSuggestUsernames([])
                } else {
                  setAutoSuggestUsernames(usernames)
                }
                setLoadData(false)
                setIsLoading(false)

              }).catch((error) => {
                setLoadData(false)
                setAutoCompleteSearchOptionMessage("No record found.")
              })
          }

          loadUsernames()
      }

      
      if(searchUsername == null){
        
        fetchAutoSuggestSellerUsername("")
      }else{
        fetchAutoSuggestSellerUsername(searchUsername.name)
      }

    },[searchUsername])

    useEffect(() => {
      
      if(!isLoading){
        return
      }
      // setAppBarWidth(elementRef.current.getBoundingClientRect().width);
      fetchUsernames(searchUsername.name)
    }, [isLoading, searchUsername.name])


    const fetchUsernames = async (searchTerm) => {

      setIsLoading(true)
      setHasErrorFetchingUsername(false)

      const options = {
        method : "POST",
        url: '/TransactiSellerSyncLogs/getAllUsersSyncLogs.json',
        data: objectToFormData({search_term:searchTerm, page_number:pageNumber,start_date:formatDateToYmd(startingDate), end_date:formatDateToYmd(endingDate)})
      }

      await axios(options)
      .then(res => {

        setHasLoadingMore(false)
        setLoadData(false)
        setIsLoading(false)
        setLoadUsernames(false);
        
        const isSuccess = res.data.response.is_success
        
        if(!isSuccess){
          // setMessageDialogMessage(res.data.response.message)
          // setShowMessageDialog(true)
          setHasErrorFetchingUsername(true)
        }

        const syncLogsUsernames = res.data.response.SyncLogs
        
        setHasMoreSyncLogsToLoad(syncLogsUsernames.length > 0)
        setSyncLogsData(syncLogsData.concat(syncLogsUsernames))
        
      }).catch(error => {
        
        setHasLoadingMore(false)
        setLoadData(false)
        setIsLoading(false)
      });
      
    }
    
    const formatDateToYmd = (date) => {
      const inputDate = new Date(date);

      // Extract the year, month, and day from the date
      const year = inputDate.getFullYear();
      const month = String(inputDate.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed, so add 1
      const day = String(inputDate.getDate()).padStart(2, "0");

      // Format the date in Y-m-d format
      const formattedDate = `${year}-${month}-${day}`;

      return formattedDate
    }
    
    const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
        formData.append(key, object[key]);
        return formData;
    }, new FormData());


    function dateRangeFilterDialog(){
        return (
          <Dialog
            fullWidth={true}
            open={openDateFilterDialog}
            onClose={()=>{}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Filter date"}</DialogTitle>
            <DialogContent>
              <Grid container spacing={1}>
                    <Grid item xs={12}>
                        
    
                        <StyledEngineProvider injectFirst>
                            <ThemeProvider theme={materialTheme}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <MobileDatePicker
                                    inputFormat="MMMM d, yyyy"
                                    value={startingDate}
                                    open={openStartingDateCalendar}
                                    onChange={(date)=>{ setStartingDate(date)}}
                                    onOpen={() => setOpenStartingDateCalendar(true)}
                                    onClose={() => setOpenStartingDateCalendar(false)}
                                    renderInput={(params) => 
                                        <TextField 
                                            {...params} 
                                            label={"Starting date"}
                                            style={{width:"99%",margin:"1%"}}
                                            InputProps={{
                                                endAdornment: (
                                                  <InputAdornment position="end">
                                                    <IconButton edge="end" onClick={()=>{setOpenStartingDateCalendar(true)}}>
                                                      <EventIcon />
                                                    </IconButton>
                                                  </InputAdornment>
                                                ),
                                              }}
                                            />
                                        }
                                    />
                                </LocalizationProvider>
                            </ThemeProvider>
                        </StyledEngineProvider>  
    
                    </Grid>
    
                    <Grid item xs={12}>
                        <StyledEngineProvider injectFirst>
                            <ThemeProvider theme={materialTheme}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <MobileDatePicker
                                    inputFormat="MMMM d, yyyy"
                                    value={endingDate}
                                    open={openEndingDateCalendar}
                                    onChange={(date)=>{ setEndingDate(date)}}
                                    onOpen={() => setOpenEndingDateCalendar(true)}
                                    onClose={() => setOpenEndingDateCalendar(false)}
                                    renderInput={(params) => 
                                        <TextField 
                                            {...params} 
                                            label={"Ending Date"}
                                            style={{width:"99%",margin:"1%"}}
                                            InputProps={{
                                                endAdornment: (
                                                  <InputAdornment position="end">
                                                    <IconButton edge="end" onClick={()=>{setOpenEndingDateCalendar(true)}}>
                                                      <EventIcon />
                                                    </IconButton>
                                                  </InputAdornment>
                                                ),
                                              }}
                                            />
                                        }
                                    />
                                </LocalizationProvider>
                            </ThemeProvider>
                        </StyledEngineProvider>  
    
                    </Grid>
              </Grid>
              {dateError && (
                <Typography style={{margin:"1%"}} variant="body2" color="error">
                  Starting date cannot be greater than ending date.
                </Typography>
            )}

            </DialogContent>
            <DialogActions>
              <Button 
              onClick={()=>{
                if (formatDateToYmd(startingDate) > formatDateToYmd(endingDate)) {
                  setDateError(true);
                } else {
                  setOpenDateFilterDialog(false);
                  setStartingFilterDate(startingDate);
                  setEndingFilterDate(endingDate);
    
                  setPageNumber(1);
                  setSyncLogsData([]);
                  setLoadData(true);
                  setIsLoading(true);
                  setDateError(false); 
                }
              }}
                color="primary" 
                autoFocus>
    
                Continue
              </Button>
            </DialogActions>
          </Dialog>
        );
    }
    
    const search = () => {
        return (
        <div position="static" style={{border:".1rem solid #989898",borderRadius:"4px",margin:'2px'}}>
            <Toolbar variant="dense" style={{padding:'0'}}>
                <Box flexGrow={1}>{autoComplete()}</Box>
                <Box>
                <IconButton 
                    className={classes.margin} 
                    size="large"
                    onClick={()=>{
                      setSyncLogsData([])
                      setPageNumber(1)
                      setIsLoading(true)
                    }}>
                <SearchIcon />
                </IconButton>
                </Box>
            </Toolbar>
        </div>
        );
    }

    const autoComplete = () => {
        return (
          <Autocomplete
                value={searchUsername}
                noOptionsText={autoCompleteSearchOptionMessage}
                onChange={(event, newValue) => {
                 
                
                  if(newValue==null || newValue.name===""){
                    searchUsername.name = ""
                    return
                  }
                  searchUsername.name = newValue.name
                  setSyncLogsData([])
                  setPageNumber(1)
                  setLoadData(true)
                  setIsLoading(true)
                }}
                
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                options={autoSuggestUsernames}
                isOptionEqualToValue={(option, value) =>true}
                getOptionLabel={(option) => {
                   
                      return option.name;
                }}
                renderOption={(props, option) => {
                  return (
                    <li {...props} key={option.name}>
                      {option.name}
                    </li>
                  );
                }}
                style={{ width: '100%',paddingLeft:'8px'}}
                renderInput={(params) => (
                  <TextField
                   {...params}
                   variant='standard'  
                   InputProps={{...params.InputProps, disableUnderline: true}}  
                   
                    onChange={(event)=>{ 
                        setSearchUsername({name:event.target.value})
                    }
                  } />
                )}
              />
        );
    }
    
  
    const orderingBody = () => {
      return(
        <React.Fragment>
        {search()}
        <Typography variant="body1" fontWeight="bold" style={{marginLeft: '1rem' }}>
        Filter Date : {formattedStartDate} - {formattedEndDate}
                </Typography>
        <CssBaseline /> 
          {isLoading ? <LinearProgress color="secondary"  style={{marginLeft:'.1rem',marginRight:'.1rem'}}/> : ''}
          {syncLogsList()}
          {hasLoadingMore ? <LinearProgress color="secondary"  style={{marginLeft:'.1rem',marginRight:'.1rem'}}/> : ''}
        </React.Fragment>
      )
    }

    const  syncLogsList = () => {
      return (
        <>
          {
            syncLogsData.map((syncLog, index) => (
              (syncLogsData.length  === index + 1) ?
                (
                  <React.Fragment key={index+syncLog.id+"synclog"} >
                    <ListItem 
                      ref={lastSyncLogsElement} 
                      key={index+syncLog.id+"synclog"} 
                      divider 
                      onClick={
                          (event)=>{
                            setSelectedUser(syncLog)
                            setSelectedUserAnchorElement(event.currentTarget)
                            setSyncLogsActions("view_seller_sync_logs")
                            setOpenSyncLogsFunctionDialog(true)
                            }
                          }
                    >
                      {syncLogElement(syncLog)}
                    </ListItem>
                  </React.Fragment>
                )
                : 
                (
                  <React.Fragment key={index+syncLog.id+"synclog"}>
                    <ListItem 
                      key={index+syncLog.id+"synclog"} 
                      divider  
                      style={{ boxShadow: 'none !important' }}
                      onClick={
                        (event)=>{
                            setSelectedUser(syncLog)
                            setSelectedUserAnchorElement(event.currentTarget)

                            setSyncLogsActions("view_seller_sync_logs")
                            setOpenSyncLogsFunctionDialog(true)
                          }
                        }
                      >
                      {syncLogElement(syncLog)} 
                    </ListItem>
                </React.Fragment>
                )
              )
            )
          }
        </>
      )

    }

    useEffect(()=> {

    },[openSyncLogsFunctionDialog])

    const syncLogElement = (syncLog) => {
      return (
        <div>
          <Typography variant="h6" gutterBottom>
            {syncLog.username}
          </Typography>
          <Grid container spacing={1} alignItems="center">
            <Grid item>
              <SyncIcon fontSize="small" style={{ verticalAlign: 'middle' }} />
            </Grid>
            <Grid item>
               {syncLog.sync_logs_count} <b>day(s) with Sync</b> / {syncLog.total_sync_days} <b>day(s)</b>
            </Grid>
          </Grid>
          <Grid container spacing={1} alignItems="center">
            <Grid item>
              <span style={{ color: "green" }}><CheckCircleOutlineIcon fontSize="small" style={{ verticalAlign: 'middle' }} /></span>
            </Grid>
            <Grid item>
              Success count: {syncLog.success}
            </Grid>
          </Grid>
          <Grid container spacing={1} alignItems="center">
            <Grid item>
              <span style={{ color: "red" }}><HighlightOffIcon fontSize="small" style={{ verticalAlign: 'middle' }} /></span>
            </Grid>
            <Grid item>
              Error count: {syncLog.error}
            </Grid>
          </Grid>
        </div>
      );
    }

    const formatDateTimeToReadableFormat = (date) => {
        const inputDate = new Date(date);

        const options = {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: true,
        };

        const formattedDate = inputDate.toLocaleString('en-US', options);

        return formattedDate;
    }

    const getSyncTimeInterval = (sync_start_date, sync_end_date) => {

      const startDate = new Date(sync_start_date);
      const endDate = new Date(sync_end_date);

      // Calculate the difference in milliseconds
      const timeDifference = endDate - startDate;

      // Convert milliseconds to minutes
      const intervalInMinutes = timeDifference / (1000 * 60);

      return intervalInMinutes;

    }

    const selectedStartDate = new Date(startingDate);
    const selectedEndDate = new Date(endingFilterDate);
    const formattedStartDate = selectedStartDate.toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
                year: "numeric"
            });
    const formattedEndDate = selectedEndDate.toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
                year: "numeric"
            });

    return (
        <>
        <div>
            <CssBaseline />
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={props.handleDrawerToggle}
                className={classes.menuButton}
                size="large">
                    <MenuIcon />
                </IconButton>
                <Typography variant="subtitle1" noWrap>
                    Seller Sync Logs
                </Typography>
                <div className={classes.grow} />
                    <IconButton className={classes.margin} onClick={menuHandleClick} edge="end"><MoreVertIcon/></IconButton>
                    <Menu id="simple-menu" open={openMenu} anchorEl={menuAnchorEl} onClose={()=>{setMenuAnchorEl(null)}}> 
                        <MenuItem 
                            onClick={() => {
                                    setOpenDateFilterDialog(true)
                                    menuHandleClose()
                                }
                            }
                        >
                            <FilterAltIcon/>  Filter by sync date
                        </MenuItem>
                    </Menu>
                </Toolbar>
            </AppBar>
    
        {
          openSyncLogsFunctionDialog 
          &&
          <ViewUserDaysWithSyncLogsFunctions 
            setOpenSyncLogsFunctionDialog = {setOpenSyncLogsFunctionDialog}
            openSyncLogsFunctionDialog = {openSyncLogsFunctionDialog}
            setSelectedUser = {setSelectedUser}
            selectedUser = {selectedUser}
          /> 
        }
        </div>
        {orderingBody()}
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={materialTheme}>
            {dateRangeFilterDialog()}
            </ThemeProvider>
        </StyledEngineProvider>

        </>

    )
}